// ========================================
// חיבור ל-Supabase
// ========================================
import { createClient } from '@supabase/supabase-js';

// הגדרות הפרויקט
const supabaseUrl = 'https://jedvhhoklypzxwbwqjgb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImplZHZoaG9rbHlwenh3YndxamdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUzOTMzOTEsImV4cCI6MjA4MDk2OTM5MX0.z_2XVTvzE6H2_Ejs1KWUBBKZygEHrETf_AO8b6fZSRc';

// יצירת הלקוח
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
